if (!window.customElements.get("pickup-availability")) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      this.colorSchemeDrawer = this.dataset.colorScheme;
      this.template = this.querySelector("template");
      this.errorHTML = this.template.content.firstElementChild.cloneNode(true);

      if (this.hasAttribute("is-pickup-available")) {
        this.parsePickupAvailability(this.dataset.variantId);
      }
    }

    parsePickupAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;

      if (rootUrl.slice(-1) !== "/") {
        rootUrl = `${rootUrl}/`;
      }

      fetch(`${rootUrl}variants/${variantId}/?section_id=pickup-availability`)
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          const parsedHTML = new DOMParser().parseFromString(text, "text/html");
          const section = parsedHTML.querySelector(".shopify-section");

          this.showAvailability(section);
        })
        .catch((e) => {
          this.innerHTML = "";
          this.appendChild(this.errorHTML);

          const button = this.querySelector("button");

          button?.addEventListener("click", () => {
            this.parsePickupAvailability(this.dataset.variantId);
          });
        });
    }

    showAvailability(section) {
      const container = document.querySelector(".pickup-availability-container");

      container?.remove();

      if (!section.querySelector(".pickup-availability-content")) {
        this.innerHTML = "";
        this.removeAttribute("is-pickup-available");

        return;
      }

      this.innerHTML = section.querySelector("pickup-availability-content").outerHTML;

      this.setAttribute("is-pickup-available", "");

      const containerInner = section.querySelector("pickup-availability-container");

      containerInner.classList.add(`color-${this.colorSchemeDrawer}`);

      document.body.appendChild(section.querySelector(".pickup-availability-container"));

      const button = this.querySelector("button");
      const newContainer = document.querySelector(".pickup-availability-container");
      const overlay = newContainer.querySelector(".overlay");

      setTimeout(() => {
        button?.addEventListener("click", (event) => {
          event.preventDefault();

          const target = event.currentTarget;
          const container = document.querySelector("pickup-availability-container");

          if (!container) {
            return;
          }

          if (!target.classList.contains("open")) {
            container.open();
          } else {
            container.close();
          }
        });

        overlay?.addEventListener("click", (event) => {
          event.preventDefault();

          const container = document.querySelector("pickup-availability-container");

          if (container?.classList.contains("open")) {
            container.close();
          }
        });
      }, 800);
    }
  }

  customElements.define("pickup-availability", PickupAvailability);
}

if (!window.customElements.get("pickup-availability-container")) {
  class PickupAvailabilityContainer extends Drawer {
    constructor() {
      super();
    }
  }

  customElements.define("pickup-availability-container", PickupAvailabilityContainer);
}
